import React from 'react';
import NoDataDisplay from 'components/NoDataDisplay/NoDataDisplay';
import LoadingSpinner from 'components/LoadingSpinner';
import { currencyFormatter } from 'utils/formatter';
import TableWithChild from './TableWithChild';
import styles from './ModifierSales.css';

function buildRowData(entry) {
  const { name, quantitySold, grossSales } = entry;
  return {
    name,
    quantitySold,
    grossSales: currencyFormatter(grossSales),
  };
}

function buildTableData(modifierSalesReport) {
  const { modifierSales, totalQuantity, totalGrossSales } = modifierSalesReport;
  const childBody = [];
  const childFoot = {
    name: 'Total',
    total_quantity: totalQuantity,
    total_gross_sales: currencyFormatter(totalGrossSales),
  };

  for (const modifier of modifierSales) {
    childBody.push({
      data: buildRowData(modifier),
      isParent: true,
    });

    for (const option of modifier.modifierOptions) {
      childBody.push({
        data: buildRowData(option),
        isParent: false,
      });
    }
  }

  return [childBody, childFoot];
}

function SimpleModifierSalesTable(props) {
  const { modifierSalesReport, isLoading } = props;
  const { modifierSales } = modifierSalesReport;
  const [childBodyResponsive, childFootResponsive] = buildTableData(
    modifierSalesReport
  );
  return (
    <div className={styles.tableWrapperResponsive}>
      <LoadingSpinner showLoadingSpinner={isLoading} />
      {modifierSales.length > 0 && (
        <TableWithChild
          headerBody={['Name', 'Quantity Sold', 'Gross Sales']}
          childBody={childBodyResponsive}
          footBody={childFootResponsive}
          tableClass="modifier-sales-table-responsive"
          headerBodyClassName={[
            'header-name',
            'header-quantity-sold',
            'header-gross-sales',
          ]}
          childBodyClassName={[
            'body-name',
            'body-quantity-sold',
            'body-gross-sales',
          ]}
          footBodyClassName={[
            'foot-name',
            'foot-quantity-sold',
            'foot-gross-sales',
          ]}
        />
      )}
      {!modifierSales.length && !isLoading && (
        <div className="no-data-display-container">
          <NoDataDisplay title="No Data to Display" />
        </div>
      )}
    </div>
  );
}

export default SimpleModifierSalesTable;
